import React from "react";
import { Form, Label } from "semantic-ui-react";

const RadioInput = ({
  input: { checked, ...rest },
  width,
  type,
  label,
  disabled,
  meta: { touched, error }
}) => {
  //console.log(input);
  return (
    <Form.Field error={touched && !!error}>
      <div className="ui radio">
        <input {...rest} type={type} checked={checked} disabled={disabled} />
        <label>{label}</label>
      </div>
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default RadioInput;
